<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <form @submit.prevent="submit" class="card-body">
        <div class="row">
          <div class="col-md-6">
            <label class="form-control-label" for="Name">نام و نام خانوادگی</label>
            <input class="form-control" type="text" id="Name" name="Name" v-model.trim="name" disabled />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="userName">کد ملی</label>
            <input class="form-control" type="text" id="username" name="username" v-model.trim="username" disabled />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="UFPassword">رمز عبور جدید</label>
            <input class="form-control" type="password" id="UFPassword" name="UFPassword" v-model.trim="password" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="UFRePassword">تکرار رمز عبور جدید</label>
            <input class="form-control" type="password" id="UFRePassword" name="UFRePassword"
              v-model.trim="rePassword" />
          </div>
        </div>
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit">ثبت</button>
          <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import UserService from '@/services/User/User-service.js';
import { maxLength, sameAs, helpers, required, minLength } from '@vuelidate/validators';

export default {
  data() {
    return {
      v: this.$useVuelidate(),
      userId: null,
      name: '',
      username: '',
      password: '',
      rePassword: '',
    };
  },
  methods: {
    submit() {

      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      let editedUser = {
        Id: this.userId,
        NewPassword: this.password,
      };

      UserService.updatePass(editedUser).then(response => {
        let result = response.data;

        if (!result.success) {
          this.$toast.error(result.message);
        } else {
          this.$toast.success(result.message);

          setTimeout(() => this.$router.back(), 500);
        }
      }).catch(e => {
        console.log(e);
      });

      this.v.$reset();
    },
    getUser() {
      UserService.find(this.userId).then(response => {
        let result = response.data;

        if (result.success) {
          this.name = result.data.lastName + ' ' + result.data.firstName;
          this.username = result.data.username;
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    goBack() {
      this.$router.back();
    }
  },
  created() {
    this.userId = this.$route.params.userId;

    this.getUser();
  },
  validations() {
    let valObj = {
      password: {
        required: helpers.withMessage('لطفا "رمز عبور جدید" را وارد کنید', required),
        maxLength: helpers.withMessage('حد اکثر طول مجاز برای "رمز عبور جدید"، 50 کاراکتر است', maxLength(50)),
        minLength: helpers.withMessage('"رمز عبور جدید" باید حداقل شامل 5 کاراکتر باشد', minLength(5)),
      },
      rePassword: {
        sameAsPassword: helpers.withMessage('"تکرار رمز عبور جدید" با "رمز عبور جدید" تفاوت دارد', sameAs(this.password)),
      },
    };

    return valObj;
  }
}
</script>